enum Sport {
  Archery = 'Archery',
  Badminton = 'Badminton',
  Baseball = 'Baseball',
  Basketball = 'Basketball',
  BassFishing = 'Bass Fishing',
  Bowling = 'Bowling',
  CanoePaddling = 'Canoe Paddling',
  Cheer = 'Cheer',
  Cricket = 'Cricket',
  CrossCountry = 'Cross Country',
  DanceTeam = 'Dance Team',
  Drill = 'Drill',
  Fencing = 'Fencing',
  FieldHockey = 'Field Hockey',
  FlagFootball = 'Flag Football',
  Football = 'Football',
  Golf = 'Golf',
  Gymnastics = 'Gymnastics',
  IceHockey = 'Ice Hockey',
  IndoorTrackField = 'Indoor Track & Field',
  Judo = 'Judo',
  Lacrosse = 'Lacrosse',
  Poms = 'Poms',
  Riflery = 'Riflery',
  Rugby = 'Rugby',
  BeachVolleyball = 'Beach Volleyball',
  SkiSnowboard = 'Ski Snowboard',
  SlowPitchSoftball = 'Slow Pitch Softball',
  Soccer = 'Soccer',
  Softball = 'Softball',
  Speech = 'Speech',
  Swimming = 'Swimming',
  Tennis = 'Tennis',
  TrackField = 'Track & Field',
  Volleyball = 'Volleyball',
  WaterPolo = 'Water Polo',
  Waterpolo = 'Waterpolo',
  WeightLifting = 'Weight Lifting',
  WheelchairSports = 'Wheelchair Sports',
  Wrestling = 'Wrestling'
}

export default Sport;
